import textToSpeechActions from '../actions/TextToSpeechActions';

const defaultState = {
    hasValidSelection: false,
    isEnabled: false,
    isPlaying: false,
    isAudioLoaded: false,
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case textToSpeechActions.types.TEXT_TO_SPEECH_HAS_VALID_SELECTION:
        return Object.assign({}, state, {
            hasValidSelection: action.value,
        });

    case textToSpeechActions.types.TEXT_TO_SPEECH_IS_ENABLED:
        return Object.assign({}, state, {
            isEnabled: action.value,
        });

    case textToSpeechActions.types.TEXT_TO_SPEECH_IS_PLAYING:
        return Object.assign({}, state, {
            isPlaying: action.value,
        });

    case textToSpeechActions.types.TEXT_TO_SPEECH_IS_AUDIO_LOADED:
        return Object.assign({}, state, {
            isAudioLoaded: action.value,
        });

    default:
        return state;
    }
}
